import { gql } from '@apollo/client';

const typeDefs = gql`
  scalar JSON

  type ModularPDPUI {
    modularParentSlug: String
    modularTotalPrice: Int
    modularBundleOrderStatus: JSON
    modularParentOrientationOptions: JSON
    currentModularGalleryProduct: Product
    bundleProducts: [Product]
    preConfiguredProducts: [Product]
    modularAllPreConfigHeroGallery: JSON
    modularSectionalProduct: Product
  }

  type ClientABTests {
    experiments: [ABTest]
  }

  type ClientABTest {
    name: String
    variantName: String
    variantId: Int
  }

  extend type Query {
    modularPDP: ModularPDPUI
    abTests: ABTests
  }
`;

export default typeDefs;
